import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const TagContainer = styled.div`
  margin-left: 4px;
`
